"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextTooltipState = /** @class */ (function () {
    function TextTooltipState() {
        this.showPopUp = false;
    }
    return TextTooltipState;
}());
exports.default = TextTooltipState;
//# sourceMappingURL=TextTooltipState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/TextTooltip/TextTooltipState.js
// module id = 2291
// module chunks = 8